import React, {lazy, Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {LinearProgress, ThemeProvider} from '@tenancy.nz/ui';
import App from './App';
import configureStore from './reducers';
import theme from './theme';

const NotFound = lazy(() => import('./components/NotFound'));

const store = configureStore();

const root = createRoot(document.getElementById('root'));

root.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<LinearProgress />}>
          <Switch>
            <Route path="/:agencyOrPropertyID/:applicationID?">
              <App />
            </Route>
            <Route>
              <NotFound />
            </Route>
          </Switch>
        </Suspense>
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
);
